/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import _ from 'lodash';
import { useRef } from 'react';

import Cta from './PageBuilder/Cta';
import RichText, { isDeltaEmpty } from './PageBuilder/RichText';
import Text from './PageBuilder/utilities/Text';
import generateTrackDestination from './PageBuilder/utilities/trackDestination';
import ChevronLink from './oc-chevron-link';
import { H3, H5 } from './oc-h';
import ImageAttribution from './oc-image-attribution';
import ImageShareLinks from './oc-image-share-links';
import Picture from './oc-picture';
import placeholder_url from '../../placeholder';

const CardWrapper = styled.div`
  display: inline-block;
  position: relative;
  width: 100%;

  h3 {
    margin-bottom: 8px;
  }

  .posthead-wrapper {
    div {
      margin: 0;
    }

    p {
      margin: 0 0 16px;
      font-size: 14px;
      margin-bottom: 16px;

      @media (min-width: 1200px) {
        font-size: 16px;
      }
    }
  }
`;

const Media = styled.div`
  margin-bottom: 16px;
  position: relative;

  img {
    display: block;
    max-width: 100%;
    width: 100%;
  }
`;

const StyledAttribution = styled(ImageAttribution)`
  @media screen and (min-width: 768px) {
    bottom: 15px;
    right: 15px;
  }
`;

const ContentLink = styled(ChevronLink)`
  &:before {
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;

const ComparisonCard = ({
  prehead,
  heading,
  posthead,
  img,
  imgAlt,
  attribution,
  noImage,
  text,
  linkUrl,
  linkText,
  aspectRatio,
  socialShare,
  transform = 'cards',
  ctaSwitch,
  ctaProps,
  ...props
}) => {
  const CtaButtonRef = useRef(null);

  const handleCtaButtonClick = () => {
    if (CtaButtonRef.current) {
      CtaButtonRef.current?.click();
    }
  };

  if (aspectRatio) {
    aspectRatio.custom = aspectRatio.custom?.toString();
  }

  return (
    <CardWrapper {...props}>
      {!isDeltaEmpty(heading) && (
        <H3 prehead={prehead} tag="h3" font="body">
          <RichText content={heading} inline />
        </H3>
      )}
      {posthead && (
        <div className="posthead-wrapper">
          <RichText content={posthead} />
        </div>
      )}

      {img && (
        <Media>
          <Picture
            alt={imgAlt}
            aspectRatio={aspectRatio}
            source={img}
            transform={transform}
          />
          {socialShare && <ImageShareLinks imageUrl={img} />}
          <StyledAttribution copy={attribution} />
        </Media>
      )}

      <RichText content={text} />

      {ctaSwitch && (
        _.isArray(ctaProps) ? (
          ctaProps?.map(ctaPropItem => (
            <Cta {...ctaPropItem} forwardRef={CtaButtonRef} key={ctaPropItem.url} />
          ))
        ) : (
          <Cta {...ctaProps} forwardRef={CtaButtonRef} />
        )
      )}

      {!ctaSwitch && linkText && linkUrl && (
        <ContentLink
          ariaLabel={linkText}
          data-track-destination={generateTrackDestination(linkUrl)}
          data-track="learn-more"
          title={linkText}
          url={linkUrl}
        >
          <Text content={linkText} />
        </ContentLink>
      )}
    </CardWrapper>
  );
};

export default ComparisonCard;
